module.exports = __webpack_public_path__ + "static/media/Touch&Go.8c3f41e2.png";